export default __webpack_public_path__ + "static/media/hero-mobile.ed3d2fd3.png";